import { memo } from 'react';
import { HStack, VStack, Text, Heading } from '@library';
import type {
    PriceProgramAttribute,
    PriceProgramAttributeValue,
    PriceProgram as PriceProgramProps,
} from '../../../types/customStoryblokComponents';
import StoryblokResponsiveImage from '../StoryblokResponsiveImage';
import StoryblokRender from '../../StoryblokRender';

import styles from './PriceProgram.module.scss';

const PriceProgramAttributeBadge = memo(
    ({
        attributes,
        attributeValue,
    }: {
        attributeValue: PriceProgramAttributeValue;
        attributes: PriceProgramAttribute[];
    }) => {
        const attribute = attributes.find(
            attr => attr.id === attributeValue.id
        );
        if (!attribute) {
            return (
                <div>
                    Attribute with {attributeValue.id} is not specificated in
                    Price Program Comparison. Please fix id or add attribute
                </div>
            );
        }
        return (
            <HStack gap="mini" className={styles.attribute}>
                <div className={styles.badgeImage}>
                    {attribute.icon.filename ? (
                        <StoryblokResponsiveImage image={attribute.icon} />
                    ) : null}
                </div>

                <VStack>
                    <Text semiBold>
                        {attributeValue.overview_label || attribute.name}
                    </Text>
                    <Text multiline>
                        {attributeValue.overview_sub_label ||
                            attribute.sub_name}
                    </Text>
                </VStack>
            </HStack>
        );
    }
);

const PriceProgram = ({
    attributes,
    program,
}: {
    program: PriceProgramProps;
    attributes: PriceProgramAttribute[];
}) => {
    return (
        <VStack gap="small">
            <Heading h2>{program.name}</Heading>

            <VStack gap="medium">
                <div>
                    <StoryblokRender components={program.description} />
                </div>

                <div className={styles.attributes}>
                    {program.attributes.map(attributeValue => (
                        <PriceProgramAttributeBadge
                            key={attributeValue.id}
                            attributeValue={attributeValue}
                            attributes={attributes}
                        />
                    ))}
                </div>
            </VStack>
        </VStack>
    );
};

export default memo(PriceProgram);
